var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"logo small"},[_c('img',{attrs:{"src":require("./assets/img/sensuu.svg"),"alt":""}})])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }